export default function() {

  // const site = 'onc';
  const body = $('body');
  let onloadContent = $('#header-onload-content');

  body.addClass('onload-content-showing');

  if (siteTheme ==='Amphitheater') {
    onloadContent.addClass('amp_header-onload');
    onloadContent.append(`<img src="${FULLCLIENTTHEMEPATH}images/St-Josephs-Health-Amphitheater-Logo-SingleColorr.svg" alt="St. Josephs Health Amphitheater">`);
  }

  if (siteTheme ==='Oncenter') {
    onloadContent.addClass('onc_header-onload');
    onloadContent.append(`
      <img src="${FULLCLIENTTHEMEPATH}images/logo-ONCENTER-OnPageLoad.svg" alt="Oncenter">
      <a href="p/book/our-spaces" class="onc_header-onload__inner1">
        <span>Convention<br> Center</span>
      </a>
      <a href="p/book/our-spaces" class="onc_header-onload__inner2">
        <span>Arena</span>
      </a>
      <a href="p/book/our-spaces" class="onc_header-onload__inner3">
        <span>Theaters</span>
      </a>
    `);
  }


  // intersection observer for onload content container
  if (!body.hasClass('browser-ie')) {

    const onloadContentIntersecting = ([isIntersecting, target]) => {
      
      // remove onload content when scrolled out of view
      if (!isIntersecting.isIntersecting) {        
        const h = onloadContent.innerHeight();
        const st = $(window).scrollTop();
        onloadContent.remove();
        $(window).scrollTop(st - h)
        body.removeClass('onload-content-showing');
        setTimeout(function() {
        }, 100);
      }
    }
    
    const io = new IntersectionObserver(onloadContentIntersecting, {
      threshold: 0
    })
    io.observe(onloadContent[0]);

  } else {
    let ieOnloadShowing = onloadContent.length;
    let ieOnloadScroll = function() {
      var top_of_element = onloadContent.offset().top;
      var bottom_of_element = onloadContent.offset().top + onloadContent.outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();
  
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
          // the element is visible, do something
      } else {
        onloadContent.remove();
        body.removeClass('onload-content-showing');
        $('.header').css('position', 'fixed');
        ieOnloadShowing = 0;
      }
    }

    $(window).scroll(function() {
      if( ieOnloadShowing > 0) {
        ieOnloadScroll();
      } else {
        return false;
      }
    });

  }

}
